module.exports = __webpack_public_path__ + "img/pic30.5a129d96.jpg";